// import { signal, WritableSignal } from '@angular/core';

export enum BondLookupUIControlStage {
  State,
  BondFamily,
  StateBond,

  StateBondOptions,
  WriteIn,
  Penalty,
  PenaltyOptions,
  PenaltyEntered,
  BondSelectionCompleted
}

// export const bondLookupStageSignals: Record<BondLookupUIControlStage, WritableSignal<boolean>> = {
//   [BondLookupUIControlStage.State]: signal(true),
//   [BondLookupUIControlStage.BondFamily]: signal(false),
//   [BondLookupUIControlStage.StateBond]: signal(false),
//   [BondLookupUIControlStage.Penalty]: signal(false),
//   [BondLookupUIControlStage.PenaltyOptions]: signal(false),
// };

// export function isStageActive(stage: BondLookupUIControlStage): boolean {
//   return bondLookupStageSignals[stage]();
// }

// export function setStageActive(stage: BondLookupUIControlStage, active: boolean): void {
//   bondLookupStageSignals[stage].set(active);
// }

// /**
//  * Define a configuration mapping for stage visibility.
//  * For example:
//  * - If the State changes, we “reset” so that only State (always on) and BondFamily are visible.
//  * - If StateBond changes, we want State, BondFamily, and StateBond visible, while hiding PenaltyOptions.
//  * - If PenaltyOptions is changed, perhaps all stages become visible.
//  */
// const stageVisibilityConfig: Record<BondLookupUIControlStage, Record<BondLookupUIControlStage, boolean>> = {
//   [BondLookupUIControlStage.State]: {
//     [BondLookupUIControlStage.State]: true,
//     [BondLookupUIControlStage.BondFamily]: true,
//     [BondLookupUIControlStage.StateBond]: false,
//     [BondLookupUIControlStage.Penalty]: false,
//     [BondLookupUIControlStage.PenaltyOptions]: false,
//   },

//   [BondLookupUIControlStage.BondFamily]: {
//     [BondLookupUIControlStage.State]: true,
//     [BondLookupUIControlStage.BondFamily]: true,
//     [BondLookupUIControlStage.StateBond]: false,
//     [BondLookupUIControlStage.Penalty]: false,
//     [BondLookupUIControlStage.PenaltyOptions]: false,
//   },
//   // When StateBond changes, show it along with previous stages.
//   [BondLookupUIControlStage.StateBond]: {
//     [BondLookupUIControlStage.State]: true,
//     [BondLookupUIControlStage.BondFamily]: true,
//     [BondLookupUIControlStage.StateBond]: true,
//     [BondLookupUIControlStage.Penalty]: false,
//     [BondLookupUIControlStage.PenaltyOptions]: false,
//   },
//   [BondLookupUIControlStage.Penalty]: {
//     [BondLookupUIControlStage.State]: true,
//     [BondLookupUIControlStage.BondFamily]: true,
//     [BondLookupUIControlStage.StateBond]: true,
//     [BondLookupUIControlStage.Penalty]: true,
//     [BondLookupUIControlStage.PenaltyOptions]: true,
//   },
//   [BondLookupUIControlStage.PenaltyOptions]: {
//     [BondLookupUIControlStage.State]: true,
//     [BondLookupUIControlStage.BondFamily]: true,
//     [BondLookupUIControlStage.StateBond]: true,
//     [BondLookupUIControlStage.Penalty]: true,
//     [BondLookupUIControlStage.PenaltyOptions]: true,
//   },
// };

// export function updateStages(changedStage: BondLookupUIControlStage): void {
//   const config = stageVisibilityConfig[changedStage];
//   if (!config) {
//     return;
//   }
//   // Note: Object keys from a numeric enum come in as strings. Convert them back to numbers.
//   for (const key in config) {
//     const stage = Number(key) as BondLookupUIControlStage;
//     setStageActive(stage, config[stage]);
//   }
// }
